import {SearchRequest} from "@modules/onBoarding/domain/SearchRequest";
import {SearchCompanyPort} from "@modules/onBoarding/application/port/input/SearchCompanyPort";
import {CompaniesPresenter} from "@modules/onBoarding/application/port/output/CompaniesPresenter";
import {CompanyRepository} from "@modules/onBoarding/application/port/output/CompanyRepository";
import {Company} from "@modules/onBoarding/domain/Company";

export class SearchCompany<OUTPUT> implements SearchCompanyPort<OUTPUT> {

    private readonly repository: CompanyRepository
    private readonly presenter: CompaniesPresenter<OUTPUT>;

    constructor(repository: CompanyRepository, presenter: CompaniesPresenter<OUTPUT>) {
        this.repository = repository;
        this.presenter = presenter;
    }

    async execute(request: SearchRequest): Promise<OUTPUT> {
        const companies: Company[] = await this.repository.getCompanies(request);

        return this.presenter.display(companies);
    }

}
